import { render, staticRenderFns } from "./orderListNew.vue?vue&type=template&id=4a3c6c7a&scoped=true&"
import script from "./orderListNew.vue?vue&type=script&lang=js&"
export * from "./orderListNew.vue?vue&type=script&lang=js&"
import style0 from "./orderListNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderListNew.vue?vue&type=style&index=1&id=4a3c6c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c6c7a",
  null
  
)

component.options.__file = "orderListNew.vue"
export default component.exports